import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { I18nModule } from "@spartacus/core";
import { IconModule, KeyboardFocusModule } from '@spartacus/storefront';
import { GenProductImageZoomViewComponent } from './product-image-zoom-view/product-image-zoom-view.component';
import { ProductImageZoomDialogComponent } from "@spartacus/product/image-zoom/components";

@Component({
  selector: 'gen-product-image-zoom-dialog',
  templateUrl: './product-image-zoom-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, I18nModule, IconModule, KeyboardFocusModule, GenProductImageZoomViewComponent],
})
export class GenProductImageZoomDialogComponent extends ProductImageZoomDialogComponent { 

  @Input() override galleryIndex: number;
}
